import { z } from 'zod';

import { CompanyProbationReviewTermMode } from '@/common/graphql';

const CompanyRelationSummary = z.object({
  id: z.string().default(''),
  name: z.string().default(''),
});

export const Company = z.object({
  id: z.string().default(''),
  name: z.string().default(''),
  country: z.object({
    id: z.string().default(''),
    name: z.string().default(''),
  }),
  parentCompany: CompanyRelationSummary.nullable().default(null),
  childrenCompanies: z.array(CompanyRelationSummary).default([]),
  locationId: z.string().default(''),
  probationReviewTerm: z.object({
    length: z.number().min(0).default(3),
    mode: z.nativeEnum(CompanyProbationReviewTermMode).default(CompanyProbationReviewTermMode.Month),
  }),
  probationReviewTimes: z.number().min(0).default(3),
  googleOrgUnitPath: z.string().default('/'),
  hrEmailAddress: z.array(z.string()).nullable().catch([]),
  jobTitleCanBeEmpty: z.boolean().default(false),
  createPerformanceReviewAutomatically: z.boolean().default(true),
  activeEmployeeCount: z.number().default(0),
  enabled: z.boolean().default(true),
  acquiredDate: z.string().nullable().default(null),
  slackTeam: z
    .object({
      teamId: z.string().nullable().default(null),
      teamName: z.string().nullable().default(null),
    })
    .nullable()
    .default(null),
  preferredLanguage: z.string().default('en'),
  createdAt: z.string().default(''),
  updatedAt: z.string().default(''),
});
export type CompanyType = z.infer<typeof Company>;
